import { useContext } from "react";
import { AppAppProviderContext } from "src/App/AppApiProvider.tsx";

export const useAppApi = () => {
  const context = useContext(AppAppProviderContext);

  if (!context) {
    throw new Error("useAppApi must be used within the AppAppProvider");
  }

  return context;
};
